<template>
  <ExternalQueryList
      endpoint="/api/v2/project-categories"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="projectCategory => $router.push(getUrl(projectCategory))"
  >
    <template v-slot:default="{ row: projectCategory }">
      <td>
        <router-link :to="getUrl(projectCategory)">
          {{ projectCategory.attributes.name }}
        </router-link>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  computed: {
    headlines() {
      return [
        {width: 22, text: 'Name'}
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(projectCategory) {
      return '/project-categories/' + projectCategory.id + '/edit'
    }
  }
}
</script>
